import axios from 'axios'
import router from '../router'
import { addAxiosRecord } from '../utils/statistic'

// 访问接口基地址

// const baseUrl = 'http://192.168.31.115:9082/' // 开发服务器基地址(马)
// const baseUrl = 'http://192.168.31.115:9082/' // 开发服务器基地址（雷）
// const baseUrl = 'http://120.27.16.129:9082/' // 测试服务器基地址

// const baseUrl = 'http://testadmin.outiejun.com:9082/' // 测试服务器基地址
// const baseUrl = 'https://test204.fengmap.com/lmweb/' // 生产服务器基地址
const baseUrl = 'http://apiapp.osechina.cn/' // 生产服务器基地址

axios.defaults.baseURL = baseUrl

// axios.defaults.timeout = 8000
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// axios 请求拦截添加token
axios.interceptors.request.use((config) => {
  const tokenStr = localStorage.getItem('tokenStr')
  const tokenMoment = sessionStorage.getItem('tokenStr')
  if (tokenStr) {
    config.headers.Authorization = `${tokenStr}`
  } else if (tokenMoment) {
    config.headers.Authorization = `${tokenMoment}`
  }

  addAxiosRecord(config)
  return config
},
(error) => {
  return Promise.reject(error)
})

// axios 响应拦截
axios.interceptors.response.use((res) => {
  if (!res.data.success) { return Promise.resolve(res) }
  return res
}, (error) => {
  const resErr = error.response
  if (resErr && Number(resErr.status) === 401) {
    this.$message.error('请重新登录')
    localStorage.removeItem('tokenStr')
    sessionStorage.removeItem('tokenStr')
    router.replace('/login')
  }
  return Promise.reject(error)
})

// 封装 axios post请求
const post = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(Response => {
        resolve(Response)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// 封装 axios get 请求
const get = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.get(url, { params: params })
      .then(response => {
        resolve(response)
      }, err => { reject(err) })
      .catch((error) => {
        reject(error)
      })
  })
}

export default axios
export { post, get, baseUrl }
